import React, { useState } from 'react';
import { 
    Popper, 
    Paper, 
    ClickAwayListener, 
    TextField, 
    Typography, 
    Divider,
    List,
    ListItem,
    ListItemText,
    InputAdornment,
    MenuItem
} from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import { textFieldSX } from '../../constants/textFieldCSS';

interface ToolSelectionPopperProps {
    open: boolean;
    anchorEl: HTMLElement | null;
    onClose: () => void;
    onToolSelect: (service: string, action: string) => void;
    availableActivities: any[] | undefined;
    isLoadingActivities: boolean;
}

const ToolSelectionPopper: React.FC<ToolSelectionPopperProps> = ({
    open,
    anchorEl,
    onClose,
    onToolSelect,
    availableActivities = [],
    isLoadingActivities
}) => {
    const [searchTerm, setSearchTerm] = useState('');

    // Filter activities based on search term
    const filteredActivities = availableActivities?.filter(activity => 
        activity.name.toLowerCase().includes(searchTerm.toLowerCase())
    ) || [];

    return (
        <Popper
            open={open}
            anchorEl={anchorEl}
            placement="bottom-start"
            style={{ zIndex: 1300, width: 350 }}
        >
            <ClickAwayListener onClickAway={onClose}>
                <Paper className="p-4 shadow-lg max-h-[500px] overflow-y-auto">
                    <Typography variant="h6" className="mb-3">
                        Select a Tool
                    </Typography>
                    
                    <TextField
                        fullWidth
                        placeholder="Search tools..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        size="small"
                        sx={textFieldSX}
                        className="mb-3"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon fontSize="small" />
                                </InputAdornment>
                            ),
                        }}
                    />
                    
                    <Divider className="mb-3" />
                    
                    <List>
                        {isLoadingActivities ? (
                            <MenuItem disabled>Loading activities...</MenuItem>
                        ) : filteredActivities.length === 0 ? (
                            <Typography variant="body2" className="text-gray-500 text-center py-4">
                                No tools found matching your search
                            </Typography>
                        ) : (
                            filteredActivities.map((activity) => (
                                <MenuItem 
                                    key={activity.name}
                                    onClick={() => onToolSelect('agent', activity.name)}
                                >
                                    {activity.name}
                                </MenuItem>
                            ))
                        )}
                    </List>
                </Paper>
            </ClickAwayListener>
        </Popper>
    );
};

export default ToolSelectionPopper; 